module.exports = __webpack_public_path__ + "img/profilepic.f9eca03e.jpg";